module.exports = __webpack_public_path__ + "img/c-thermometer-img5-2.11e05985.png";